/**
 * Builds the query params shared across suppliers-balance navigation (overview ↔ detail ↔ sidebar). Centralised so
 * every link carries the same keys, and so undefined values are dropped — getQueryParamsString stringifies undefined
 * to the literal "undefined", which would otherwise leak into the URL (AUDIT-126).
 */
export interface SuppliersBalanceNavParams {
  period?: string
  searchQuery?: string
}

export const buildSuppliersBalanceNavQuery = ({
  period,
  searchQuery,
}: SuppliersBalanceNavParams): Record<string, string> => ({
  ...(period ? { period } : {}),
  ...(searchQuery ? { searchQuery } : {}),
})
